export default class MainPageFirstScreenCommon {
    public static readonly selectors = {
        screen: ".js-main-page-hero-section",
        mainPoint: ".js-main-page-hero-section-main-image",
        label: ".js-main-page-hero-section-labels-item",
    };
}
